import React, {Component} from "react";
import {Link} from "react-router-dom";
import Constent from '../../networking/Constent';
import {post} from './../../networking/Api';
import { database } from './firebase';
import moment from 'moment';
import ImageUploader from 'react-images-upload';
import { withTranslation } from 'react-i18next';
import "./../../Chat.css";

const dummyImage =  process.env.PUBLIC_URL + '/assets/img/placeholder.png';
var employees = {
  chatlist: []
};

class UserChat extends Component {
    constructor(props) {
      super(props);
      
      this.state={
          user_id: '',
          chat_with_user_id:'',
          chat_id:'',
          name:'',
          last_name:'',
          profile_image: dummyImage,
          username:'',
          phone_no:'',
          app_name:'',

          my_profile_image : (localStorage.getItem('user_data') === null) ? dummyImage : JSON.parse(localStorage.getItem('user_data')).profile_image,
          users:[],
          message:[],
          messagess:'',
         // id:'', // chat_id
          showEmojis: false,
          large_image:''
        }
        this.onDrop = this.onDrop.bind(this);
    }

    componentDidMount(){
        localStorage.setItem('temp_data', 'srb')
        var user_id= localStorage.getItem('userid');
        this.setState({user_id:user_id});
        this.setState({chat_with_user_id:this.props.match.params.id});
        this.handleCheckChat();        
        this.scrollToBottom();
    }

    componentDidUpdate() {
      this.scrollToBottom();
    }
    handleCheckChat() {
        var formData=new FormData();
        formData.append("user_id", localStorage.getItem('userid'));
        formData.append("chat_with", this.props.match.params.id);
        post(Constent.CHECKUSERCHAT,formData).then(response=>{
            if(response.status===1){
                this.setState({
                    chat_id:response.chat.id,
                    name : response.chat_with.first_name,
                    last_name : response.chat_with.last_name,
                    username : response.chat_with.username,
                    phone_no : response.chat_with.phone_no,
                    profile_image: response.chat_with.profile_image,
                    app_name: response.chat_with.app_name
                });
                this.loadChat();
            }         
        })   
    };

    loadChat(){
        var chat_id= this.state.chat_id;
        const userRef = database.ref(this.state.app_name+'_chats/'+chat_id)
        .orderByKey()
        .limitToLast(500);

      userRef.once('value', snapshot => {
        const users = [snapshot.val()];

        this.setState({users: users});
        var result = [];

        employees.chatlist = [];
        if(users[0] != null){
          result = Object.keys(users[0]).map(function(key) {
            return [String(key), users[0][key]];
          });
        }
          result.map(function(item) { 
            employees.chatlist.push({ 
              "date" : item[1].date,
              "msg"  : item[1].text,
              "userId"  : item[1].userId,
              "is_image"  : item[1].is_image,
              "isRead"  : (item[1].isRead) ? item[1].isRead : '',
            });
             return true;
          });
          this.setState({message:employees.chatlist});
        });
 
        this.scrollToBottom();
    };
    
scrollToBottom = () => {
  this.messagesEnd.scrollIntoView({ behavior: "smooth" });
}

handleChange = e => {
  this.setState({ messagess: e.target.value })
}

addEmoji = e => {
  let emoji = e.native;
  this.setState({
    messagess: this.state.messagess + emoji
  });
};
showEmojis = e => {
  this.setState(
    {
      showEmojis: true
    },
    () => document.addEventListener("click", this.closeMenu)
  );
};

closeMenu = e => {
  if (this.emojiPicker !== null && !this.emojiPicker.contains(e.target)) {
    this.setState(
      {
        showEmojis: false
      },
      () => document.removeEventListener("click", this.closeMenu)
    );
  }
};

onDrop(pictureFiles, pictureDataURLs) {
 database.ref( this.state.app_name+'_chats/'+this.state.chat_id).push({date:moment().format(), text: pictureDataURLs,userId: this.state.user_id, is_image: true}).once('value', snapshot => {
      const users = [snapshot.val()];
      employees.chatlist.push({ 
          "date" : users[0].date,
          "msg"  : users[0].text,
          "userId"  : users[0].userId,
          "is_image" : true,
          "isRead" : "unread",
      });
    this.setState({messagess:''})
    this.setState({message:employees.chatlist});
  });
}      

    render() {
        const { t } = this.props;
        return (
        <>
                {/* Header Starts */}

                <div className="header-area timeregistraionpage" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-2 col-2 pl-0">
                                <Link className="menu-back-page home-clicked" to={'/chat'}>
                                    <i  style={{fontSize: 25,marginTop: 8}} className="fa fa-reply"></i>
                                </Link>
                            </div>
                            <div className="col-sm-8 col-8 text-center">
                                <div className="page-name text-overflow">{ this.state.name } { this.state.last_name }</div>
                            </div>
                            <div className="col-sm-2 col-2 text-right pr-0">
                                {this.state.phone_no.length > 0 ? 
                                    <a href={'tel:'+this.state.phone_no} className="menu-back-page">
                                    <i className="las la-phone-alt" aria-hidden="true" style={{fontSize: 25,marginTop: 8}}></i>
                                    </a>
                                : ''}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mg-top-50"></div>

            {/* Chat  start  */}
            
            <div className="card card-bordered">
              <div className="ps-container">
            {(this.state.message).length > 0 ? '' : <p className="text-center"></p>}    
            {this.state.message.map(({date,msg,userId,is_image})=>(
                
                <div key={date}>

                { localStorage.getItem('temp_data') == moment(date).format('DD/MM/YY') ? ''
                : <div className="media media-meta-day">{moment(date).format('ddd, DD MMM Y')}</div> }
                

                { localStorage.getItem('temp_data') == moment(date).format('DD/MM/YY') ? ''
                : localStorage.setItem('temp_data', moment(date).format('DD/MM/YY')) }

                
                <div key={date} className={this.state.user_id === userId? 'media media-chat media-chat-reverse' : 'media media-chat' }>
                  {this.state.user_id === userId? '' :
                    <img className="avatar" src={this.state.profile_image} alt="userimage" />
                   }
                  <div className="media-body">
                    { (is_image === true) ? <div 
                        data-toggle="modal" data-target="#image-modal"
                    onClick={()=>{
                      this.setState({large_image:msg})
                    }} > <img src={msg} alt="profile" className="chatImage"  /> </div>: <p> {msg} </p>}
                    <p className="meta"><time dateTime="2018">{moment(date).format('hh:mm a')}</time></p>
                  </div>
                </div>
                </div>
            ))}    

            <div style={{ float:"left", clear: "both" }}
                 ref={(el) => { this.messagesEnd = el; }}>
            </div>
            <div className="ps-scrollbar-x-rail" style={{left: 0, bottom: 0}}>
                <div className="ps-scrollbar-x" tabIndex="0" style={{left: 0, width: 0}}></div>
            </div>
            <div className="ps-scrollbar-y-rail" style= {{top: 0, height: 0, right: 2}}>
                <div className="ps-scrollbar-y" tabIndex="0" style={{top: 0, height: 2}}></div>
            </div>
        </div>

            <div className="publisher bt-1 border-light">
                <img className="avatar avatar-xs" src={this.state.my_profile_image} alt="userimage" />
                <input className="publisher-input form-control" type="text" placeholder={t('lang.chat_sc_write_something')}
                value={this.state.messagess}
                onChange={this.handleChange} />
                <ImageUploader
                  withIcon={false}
                  withLabel={false}
                  singleImage={true}
                  className="chatAddPhotoIcon"
                  buttonText={<i className="fa fa-paperclip file-browser"></i>}
                  onChange={this.onDrop}
                  imgExtension={['.jpg','.jpeg', '.gif', '.png', '.bmp']}
                  maxFileSize={5242880}
                  />

                <Link className="publisher-btn" to={'#'} data-abc="true"
                onClick={()=>{
                  if(this.state.messagess !== ''){
                  database.ref(this.state.app_name+'_chats/'+this.state.chat_id).push({date:moment().format(), text: this.state.messagess,userId: this.state.user_id,is_image:false,isRead:'unread'}).once('value', snapshot => {
                    const users = [snapshot.val()];
                    employees.chatlist.push({ 
                        "date" : users[0].date,
                        "msg"  : users[0].text,
                        "userId"  : users[0].userId,
                        "is_image" : false,
                        "isRead":"unread",
                    });
                
                  this.setState({messagess:''})
                  this.setState({message:employees.chatlist});
                });
                } } }
                > <i className="fa fa-paper-plane"></i></Link>
              </div>
            </div>
            {/* Chat details end  */}
            
        {/*  image-modal start */}
            <div id="image-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header" style={{background:'unset'}}>
                            <h5 className="modal-title"></h5>
                            <div className="modal-close" data-dismiss="modal" style={{background:'#cecece'}}>
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body" style={{maxHeight:'70vh',paddingTop:0}}>
                            <img src={this.state.large_image} alt="large_image" />
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default withTranslation('common')(UserChat);